// extracted by mini-css-extract-plugin
export default {"container":"kycInstruction_container__Ml1TP","btnContainer":"kycInstruction_btnContainer__m1Gnr"};